import React from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, Link } from 'react-router'
import { Box } from '@node-space/ui-components'
import { PathNames } from 'constants/General'
import { Card } from 'services/CardService'
import { CustomerWallet } from 'types/customers'
import { CardStatusHighlight } from './CardStatusHighlight'
import { formatWalletBalance } from './utils/cardUtils'

interface CardDetailsInfoProps {
  card: Card
  wallet: CustomerWallet
}

export const CardDetailsInfo: React.FC<CardDetailsInfoProps> = ({ card, wallet }) => {
  const { t } = useTranslation()

  return (
    <Box flexCol gapY={4} paddingY={4}>
      <Box tag="p" className="text-h4 text-foreground-prominent">
        ****{card.last4Digits}{' '}
        <span className="text-foreground-faint">{t('customers.cardDetails.linkedToWallet')} </span>
        <Link
          to={generatePath(PathNames.CUSTOMER_WALLET, {
            customerReference: wallet.customerReference,
            customerWalletId: wallet.id,
          })}
          className="hover:underline"
        >
          {wallet.name}
        </Link>
      </Box>

      <Box tag="h2" className="text-h2 text-foreground-prominent">
        {formatWalletBalance(wallet.balance)}
      </Box>

      <Box paddingT={4}>
        <CardStatusHighlight status={card.status} />
      </Box>
    </Box>
  )
}
